export default __webpack_public_path__ + "static/Entenda0129-b207c7355256d39befffee3f2c39b70f.jpg";